import { render, staticRenderFns } from "./AddLeaderboardForm.vue?vue&type=template&id=3ba6f9a7&"
import script from "./AddLeaderboardForm.vue?vue&type=script&lang=js&"
export * from "./AddLeaderboardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports